import React from 'react';

type IconProps = React.ComponentProps<'svg'>;

const MagicIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_192_15551)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7947 9.21817L15.1436 8.33192C14.1687 8.00764 13.4469 7.191 13.2416 6.19779L12.1231 0.737691C12.0923 0.601868 11.9691 0.5 11.8255 0.5C11.6818 0.5 11.5586 0.601868 11.5279 0.737691L10.411 6.19779C10.2057 7.191 9.48224 8.00764 8.50733 8.33192L5.85625 9.21817C5.7331 9.25891 5.651 9.37606 5.651 9.5017C5.651 9.62903 5.7331 9.74618 5.85625 9.78693L8.50733 10.6732C9.48224 10.9975 10.2057 11.8141 10.411 12.8073L11.5279 18.2623C11.5586 18.3981 11.6818 18.5 11.8255 18.5C11.9691 18.5 12.0923 18.3981 12.1231 18.2623L13.2416 12.8073C13.4469 11.8141 14.1687 10.9975 15.1436 10.6732L17.7947 9.78693C17.9178 9.74618 17.9999 9.62903 17.9999 9.5017C17.9999 9.37606 17.9178 9.25891 17.7947 9.21817ZM3.54901 4.21475L4.48287 4.53053C4.82495 4.64598 5.08151 4.92952 5.15334 5.28435L5.54844 7.21135C5.5587 7.26228 5.59975 7.29794 5.65106 7.29794C5.70237 7.29794 5.74342 7.26228 5.75368 7.21135L6.14878 5.28435C6.22062 4.93461 6.47717 4.64598 6.82096 4.53053L7.75482 4.21475C7.79416 4.20116 7.82495 4.16042 7.82495 4.11458C7.82495 4.06873 7.79416 4.02799 7.75482 4.01271L6.82096 3.69862C6.47717 3.58147 6.22062 3.29794 6.14878 2.9431L5.75368 1.0178C5.74342 0.966867 5.70237 0.931213 5.65106 0.931213C5.59975 0.931213 5.5587 0.966867 5.54844 1.0178L5.15334 2.9431C5.08151 3.29284 4.82495 3.58147 4.48287 3.69862L3.54901 4.01271C3.50796 4.02799 3.47717 4.06873 3.47717 4.11458C3.47717 4.16042 3.50796 4.20116 3.54901 4.21475ZM4.47777 13.2589L5.72805 13.6799C5.78449 13.6952 5.82554 13.7495 5.82554 13.8106C5.82554 13.8718 5.78449 13.9227 5.72805 13.9431L4.47777 14.3641C4.02109 14.5152 3.67731 14.9006 3.57982 15.3726L3.05131 17.9533C3.04105 18.0178 2.97948 18.0636 2.91277 18.0636C2.84607 18.0636 2.78962 18.0178 2.77423 17.9533L2.24572 15.3726C2.15336 14.9006 1.80958 14.5152 1.34949 14.3641L0.0974915 13.9431C0.041049 13.9278 0 13.8718 0 13.8106C0 13.7495 0.041049 13.7003 0.0974915 13.6799L1.34949 13.2589C1.80445 13.1061 2.14823 12.7207 2.24572 12.2504L2.77423 9.66973C2.78449 9.60352 2.84607 9.55768 2.91277 9.55768C2.97948 9.55768 3.03592 9.60352 3.05131 9.66973L3.57982 12.2504C3.67218 12.7207 4.01596 13.1061 4.47777 13.2589Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_192_15551">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MagicIcon;
